<template>
    <div id="list-kategori-produk">

      <div>
        <vx-card>
          <vs-row vs-w="12">
            <vs-col class="search-bar" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="4" vs-xs="12">
              <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"/>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-lg="7" vs-sm="8" vs-xs="12">
              <vs-spacer></vs-spacer>
              <vs-tooltip text="Tambah">
                <vs-button radius size="large" type="border" color="#5d9fc6" icon="person_add" class="ml-3" @click="create()"></vs-button>
              </vs-tooltip>
              <vs-tooltip text="Edit" v-if="btnEdit === true">
                <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit()"></vs-button>
              </vs-tooltip>
              <vs-tooltip text="Hapus" v-if="btnDel === true">
                <vs-button radius size="large" type="border" color="#danger" icon="delete" class="ml-3"></vs-button>
              </vs-tooltip>
            </vs-col>
          </vs-row>
        </vx-card>
      </div>

      <vx-card title="Daftar Kategori Produk" class="sticky-table-content">
        <vs-table
            stripe
            maxItems="10"
            class="mb-base"
            :data="listData"
            style="text-align:center;"
            @selected="handleSelected">
            <template slot="thead">
                <vs-th>Kode</vs-th>
                <vs-th>Nama</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':''">
                    <vs-td>
                        {{data[indextr].code}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].name}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
      </vx-card>
    </div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import master from "@/api/master.js";
import tool from "@/tool/form_tool.js";
export default {
	data() {
		return {
			idSelected: null,
			listData: [],
			loading: true,
			perPage: 50,
			page: 1,
  		totalItem: 1,
			btnEdit: false,
			btnDel: false,
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
            searchText: ''
		};
	},
	methods: {
		listen(newVal, schema) {
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			const frm = await master.listProdukGroup(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
        this.listData= {maxPage:0, data: []};
      }
		},
		async firstLoad() {
			this.find(1);
		},
		handleSelected(tr) {
			this.idSelected = tr.id;
			this.btnEdit = true;
			this.btnDel = true;
		},
		create() {
			this.$router.push('/inventory/produk/group/create');
		},
		edit() {
			this.$router.push({name: 'edit-produk-group', params: {id: this.idSelected}});
		},
	},
	computed: {},
	created() {
		this.firstLoad();
	},
};
</script>
